import api from "../../services/api";
import {
  ADD_MODULE_REQUEST,
  ADD_MODULE_SUCCESS,
  ADD_MODULE_FAILURE,
  GET_MODULES_BY_COURSE_ID_REQUEST,
  GET_MODULES_BY_COURSE_ID_SUCCESS,
  GET_MODULES_BY_COURSE_ID_FAILURE,
  UPDATE_MODULE_APPROVAL_STATUS_REQUEST,
  UPDATE_MODULE_APPROVAL_STATUS_SUCCESS,
  UPDATE_MODULE_APPROVAL_STATUS_FAILURE,
  RESET_MODULE_APPROVAL_STATUS,
  GET_MODULE_BY_ID_REQUEST,
  GET_MODULE_BY_ID_SUCCESS,
  GET_MODULE_BY_ID_FAILURE,
  UPDATE_MODULE_ORDER_REQUEST,
  UPDATE_MODULE_ORDER_SUCCESS,
  UPDATE_MODULE_ORDER_FAILURE,
  UPDATE_MODULE_REQUEST,
  UPDATE_MODULE_SUCCESS,
  UPDATE_MODULE_FAILURE,
  DELETE_MODULE_REQUEST,
  DELETE_MODULE_SUCCESS,
  DELETE_MODULE_FAILURE,
} from "./ActionType";
const addModuleRequest = () => ({ type: ADD_MODULE_REQUEST });
const addModuleSuccess = (module) => ({
  type: ADD_MODULE_SUCCESS,
  payload: module,
});
const addModuleFailure = (error) => ({
  type: ADD_MODULE_FAILURE,
  payload: error,
});
export const addModule = (request) => async (dispatch) => {
  dispatch(addModuleRequest());
  try {
    const response = await api.post(`/modules`, request.moduleData);
    const newModule = response.data;
    request.navigate(`/chapter/${newModule.id}`);
    dispatch(addModuleSuccess(newModule));
  } catch (error) {
    dispatch(addModuleFailure(error.response.data));
  }
};

const getModulesByCourseIdRequest = () => ({
  type: GET_MODULES_BY_COURSE_ID_REQUEST,
});

const getModulesByCourseIdSuccess = (modules) => ({
  type: GET_MODULES_BY_COURSE_ID_SUCCESS,
  payload: modules,
});

const getModulesByCourseIdFailure = (error) => ({
  type: GET_MODULES_BY_COURSE_ID_FAILURE,
  payload: error,
});

export const getModulesByCourseId = (courseId) => async (dispatch) => {
  dispatch(getModulesByCourseIdRequest());
  try {
    const response = await api.get(`/modules/by-course/${courseId}`);
    const modules = response.data;
    dispatch(getModulesByCourseIdSuccess(modules));
  } catch (error) {
    dispatch(getModulesByCourseIdFailure(error.response.data));
  }
};

const updateModuleApprovalStatusRequest = () => ({
  type: UPDATE_MODULE_APPROVAL_STATUS_REQUEST,
});

const updateModuleApprovalStatusSuccess = (module) => ({
  type: UPDATE_MODULE_APPROVAL_STATUS_SUCCESS,
  payload: module,
});

const updateModuleApprovalStatusFailure = (error) => ({
  type: UPDATE_MODULE_APPROVAL_STATUS_FAILURE,
  payload: error,
});

export const updateModuleApprovalStatus =
  (moduleId, status) => async (dispatch) => {
    dispatch(updateModuleApprovalStatusRequest());
    try {
      const response = await api.patch(`/modules/${moduleId}/approval-status`, {
        approvalStatus: status,
      });
      const updatedModule = response.data;
      dispatch(updateModuleApprovalStatusSuccess(updatedModule));
    } catch (error) {
      dispatch(updateModuleApprovalStatusFailure(error.response.data));
    }
  };

export const resetModuleApprovalStatus = () => ({
  type: RESET_MODULE_APPROVAL_STATUS,
});

const getModuleByIdRequest = () => ({
  type: GET_MODULE_BY_ID_REQUEST,
});

const getModuleByIdSuccess = (module) => ({
  type: GET_MODULE_BY_ID_SUCCESS,
  payload: module,
});

const getModuleByIdFailure = (error) => ({
  type: GET_MODULE_BY_ID_FAILURE,
  payload: error,
});

export const getModuleById = (moduleId) => async (dispatch) => {
  dispatch(getModuleByIdRequest());
  try {
    const response = await api.get(`/modules/${moduleId}`);
    const module = response.data;
    dispatch(getModuleByIdSuccess(module));
  } catch (error) {
    dispatch(getModuleByIdFailure(error.response.data));
  }
};

const updateModuleOrderRequest = () => ({
  type: UPDATE_MODULE_ORDER_REQUEST,
});

const updateModuleOrderSuccess = () => ({
  type: UPDATE_MODULE_ORDER_SUCCESS,
});

const updateModuleOrderFailure = (error) => ({
  type: UPDATE_MODULE_ORDER_FAILURE,
  payload: error,
});

export const updateModuleOrder = (orderMap) => async (dispatch) => {
  dispatch(updateModuleOrderRequest());
  try {
    await api.put("/modules/update-order", orderMap);
    dispatch(updateModuleOrderSuccess());
  } catch (error) {
    dispatch(updateModuleOrderFailure(error.response?.data || error.message));
  }
};

const updateModuleRequest = () => ({
  type: UPDATE_MODULE_REQUEST,
});

const updateModuleSuccess = (module) => ({
  type: UPDATE_MODULE_SUCCESS,
  payload: module,
});

const updateModuleFailure = (error) => ({
  type: UPDATE_MODULE_FAILURE,
  payload: error,
});

export const updateModule = (moduleId, moduleData) => async (dispatch) => {
  dispatch(updateModuleRequest());
  try {
    const response = await api.put(`/modules/${moduleId}`, moduleData);
    // Response format: { message: "Module updated successfully", success: true, id: "module-uuid" }
    dispatch(updateModuleSuccess(response.data));
  } catch (error) {
    dispatch(updateModuleFailure(error.response?.data || error.message));
  }
};

const deleteModuleRequest = () => ({
  type: DELETE_MODULE_REQUEST,
});

const deleteModuleSuccess = (data) => ({
  type: DELETE_MODULE_SUCCESS,
  payload: data,
});

const deleteModuleFailure = (error) => ({
  type: DELETE_MODULE_FAILURE,
  payload: error,
});

export const deleteModule = (moduleId) => async (dispatch) => {
  dispatch(deleteModuleRequest());
  try {
    const response = await api.delete(`/modules/${moduleId}`);
    dispatch(deleteModuleSuccess(response.data));
  } catch (error) {
    dispatch(deleteModuleFailure(error.response?.data || error.message));
  }
};
